var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.75,
    fill: "#F8F8F8",
    stroke: "#FB6B21",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4046 26.3407C45.2322 27.7397 45.0604 29.3263 44.888 30.8184C44.6297 32.9639 44.3714 35.0163 44.1131 37.1618C43.8548 39.3073 43.5965 41.3597 43.3382 43.5052C43.1658 44.9043 42.994 46.304 42.8216 47.7031C42.6492 49.0091 42.1326 50.0353 41.0129 50.5949C39.7215 51.1545 38.257 50.5949 37.7405 49.1958C37.3098 48.1696 37.2239 47.0503 37.0515 45.9303C36.7073 43.4113 36.4484 40.9859 36.1042 38.4669C35.8459 36.0416 35.5012 33.6157 35.2429 31.2835C35.0705 29.8844 34.9846 28.5784 34.7263 27.1785C34.1238 24.5677 35.6736 22.3293 37.3956 21.3029C40.8398 19.1574 44.7155 21.8626 45.318 25.3141C45.4045 25.5939 45.4045 25.8737 45.4045 26.3403L45.4046 26.3407Z",
    fill: "#FB6B21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5849 52.9755C42.6719 52.9755 44.3234 55.0156 44.3234 57.3463C44.3234 59.6777 42.5846 61.6203 40.4975 61.6203C38.4106 61.5234 36.6716 59.5802 36.759 57.2495C36.7596 54.6268 38.5853 52.8787 40.5849 52.9755Z",
    fill: "#FB6B21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationicon);
export default __webpack_public_path__ + "static/media/exclamationicon.615ed7792261dceef19100f4aa6c7520.svg";
export { ForwardRef as ReactComponent };